import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import styles from "./HelpLinksList.module.css";

const HelpLinksList = ({ title, titleLink, links, onLinkClick, onTitleClick }) => {
  return (
    <Box className={styles.helpLinksList}>
      <Typography 
        className={styles.title} 
        onClick={() => onTitleClick(titleLink)} // Navigate using the title link provided
      >
        {title}
      </Typography>
      <Box className={styles.linksWrapper}>
        {links.map((link, index) => (
          <Typography 
            key={index}
            className={styles.link}
            onClick={() => onLinkClick(link.link, titleLink)} // Navigate using the link provided
          >
            {link.title}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

HelpLinksList.propTypes = {
  title: PropTypes.string.isRequired,
  titleLink: PropTypes.string.isRequired, // New prop for handling title click
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired
    })
  ).isRequired,
  onLinkClick: PropTypes.func.isRequired,
};

export default HelpLinksList;